import React, { useRef } from "react";
import { withStyles } from "@material-ui/core/styles";
import cx from "classnames";

const styles = theme => ({
  customClass: {
    ...theme.typography.defaultFont,
    ...theme.customFieldPadding,
    background: "none",
    border: "none",
    borderRadius: "6px",
    fontWeight: 600,
    padding: "9px 14px",
    fontSize: "15px",
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
    "&::-webkit-input-placeholder": {
      fontWeight: 400,
      color: "#AEB5C6",
      opacity: 1
    },
    "&::placeholder": {
      fontWeight: 400,
      color: "#AEB5C6",
      opacity: 1
    }
  },
  textfield: {
    ...theme.customTextfield,
    width: "100%"
  },
  flexClass: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxSizing: "border-box",
    ["&:hover"]: {
      border: "1px solid #2A89F6"
    },
    transition: "border 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
  },
  noPadding: {
    border: "none",
    padding: "11px 0"
  },
  noBorderHover: {
    ["&:hover"]: {
      border: "1px solid #E2E5EF"
    }
  }
});

const CustomTextField = props => {
  const {
    classes,
    endAdornment,
    startAdornment,
    style,
    inputProps = {},
    inputRef = useRef(),
    autoComplete = "off",
    onClick,
    noPadding = false,
    className,
    inputClass,
    textArea = false,
    noBorderHover = false,
    ...otherProps
  } = props;
  return (
    <div
      className={cx(
        className ? className : classes.textfield,
        classes.flexClass,
        noBorderHover && classes.noBorderHover
      )}
      style={style}
      onClick={onClick}
    >
      {startAdornment ? startAdornment : null}
      {textArea ? (
        <textarea
          ref={inputRef}
          className={cx(
            inputClass,
            classes.customClass,
            noPadding && classes.noPadding
          )}
          autoComplete={autoComplete}
          {...otherProps}
          {...inputProps}
        />
      ) : (
        <input
          ref={inputRef}
          className={cx(
            inputClass,
            classes.customClass,
            noPadding && classes.noPadding
          )}
          autoComplete={autoComplete}
          {...otherProps}
          {...inputProps}
        />
      )}
      {endAdornment ? endAdornment : null}
    </div>
  );
};

export default withStyles(styles)(CustomTextField);
